import { TaxBracket } from "./types";

/**
 * Calcula el impuesto aplicando los tramos progresivos
 * Función común usada por todos los países
 */
export function calculateTaxByBrackets(
  taxableAmount: number,
  brackets: TaxBracket[]
): number {
  let tax = 0;
  for (const bracket of brackets) {
    if (taxableAmount > bracket.min) {
      const amountInBracket = Math.min(taxableAmount, bracket.max) - bracket.min;
      tax += (amountInBracket * bracket.rate) / 100;
    }
  }
  return tax;
}

/**
 * Formatea un número como moneda
 */
export function formatCurrency(amount: number, currency: string): string {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: currency,
  }).format(amount);
}

/**
 * Calcula el porcentaje efectivo
 */
export function calculateEffectiveRate(amount: number, base: number): number {
  return base > 0 ? (amount / base) * 100 : 0;
}
